/** Voice listening visual: wave (default, Gemini-style) | cryptic (gospel scramble). */

export const VOICE_CAPTURE_STYLES = ["wave", "cryptic"];
export const DEFAULT_VOICE_CAPTURE_STYLE = "wave";

const STORAGE_KEY = "trufapp_voice_capture_style";

export function isValidVoiceCaptureStyle(value) {
  return VOICE_CAPTURE_STYLES.includes(value);
}

export function getVoiceCaptureStyle(settings = {}) {
  if (isValidVoiceCaptureStyle(settings.voiceCaptureStyle)) {
    return settings.voiceCaptureStyle;
  }
  try {
    const local = localStorage.getItem(STORAGE_KEY);
    if (isValidVoiceCaptureStyle(local)) return local;
  } catch {
    /* ignore */
  }
  return DEFAULT_VOICE_CAPTURE_STYLE;
}

export function persistVoiceCaptureStyleLocal(style) {
  try {
    if (isValidVoiceCaptureStyle(style)) localStorage.setItem(STORAGE_KEY, style);
  } catch {
    /* ignore */
  }
}
